import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ReactionPicker } from "./ReactionPicker";
import { cn } from "@/lib/utils";

interface MessageHoverActionsProps {
  onReply: () => void;
  onAddReaction: (emoji: string) => void;
  existingReactions?: string[];
  className?: string;
  showReply?: boolean;
}

export const MessageHoverActions = ({
  onReply,
  onAddReaction,
  existingReactions = [],
  className,
  showReply = true,
}: MessageHoverActionsProps) => {
  return (
    <div
      className={cn(
        "absolute -top-3 right-2 flex items-center gap-0.5 bg-background border border-border rounded-md shadow-sm opacity-0 group-hover:opacity-100 transition-opacity z-10",
        className
      )}
    >
      <ReactionPicker
        onSelectEmoji={onAddReaction}
        existingReactions={existingReactions}
      />
      {showReply && (
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 text-muted-foreground hover:text-foreground"
          onClick={onReply}
        >
          <MessageSquare className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};
